__turbopack_context__.v({
  "body": "MemberCard-module-scss-module__sQkSHG__body",
  "card": "MemberCard-module-scss-module__sQkSHG__card",
  "edge": "MemberCard-module-scss-module__sQkSHG__edge",
  "fade": "MemberCard-module-scss-module__sQkSHG__fade",
  "media": "MemberCard-module-scss-module__sQkSHG__media",
  "meta": "MemberCard-module-scss-module__sQkSHG__meta",
  "name": "MemberCard-module-scss-module__sQkSHG__name",
  "party": "MemberCard-module-scss-module__sQkSHG__party",
  "photo": "MemberCard-module-scss-module__sQkSHG__photo",
  "ret": "MemberCard-module-scss-module__sQkSHG__ret",
  "retNeg": "MemberCard-module-scss-module__sQkSHG__retNeg",
  "retPos": "MemberCard-module-scss-module__sQkSHG__retPos",
  "stat": "MemberCard-module-scss-module__sQkSHG__stat",
  "statLabel": "MemberCard-module-scss-module__sQkSHG__statLabel",
  "statValue": "MemberCard-module-scss-module__sQkSHG__statValue",
  "state": "MemberCard-module-scss-module__sQkSHG__state",
  "stats": "MemberCard-module-scss-module__sQkSHG__stats",
  "toneDem": "MemberCard-module-scss-module__sQkSHG__toneDem",
  "toneInd": "MemberCard-module-scss-module__sQkSHG__toneInd",
  "toneRep": "MemberCard-module-scss-module__sQkSHG__toneRep",
});
